import type { Template, TemplateVariants } from '../entities/Template'
import { useTemplateStore } from '../stores/useTemplateStore'
import { useUserStore } from '~/modules/auth/stores/userStore'

export type useTemplateDataComposableParamsType = TemplateVariants

export const useTemplateDataComposable = async (
  params: useTemplateDataComposableParamsType,
) => {
  const userStore = useUserStore()
  userStore.$subscribe(() => {
    init()
  })

  const init = function () {
    useTemplateStoreInstance.setHeaderShowPopover(userStore.getLogged)
  }

  onMounted(() => {
    init()
  })

  const contentCall = async (): Promise<Template> => {
    const contentConstant = await import(`../constants/${params.template}.ts`)

    // @ts-ignore
    const contentQueryContent: Template = contentConstant.default

    return contentQueryContent
  }

  const data = await contentCall()
  const parsedData: Template = data

  const useTemplateStoreInstance = useTemplateStore()
  useTemplateStoreInstance.setTemplate(parsedData)
}
